/*
 * General custom scripts
 */

import { Cf7AcceptanceToggle } from './front/cf7-form-acceptance';

new Cf7AcceptanceToggle();
